import { createAndUpdateOrder } from '../order/createAndUpdateOrder.js'; // Importiere dein neues Modul
import sessionStorageModule from '../utils/sessionStorageModule.js';
import { translation } from '../utils/translate.js';
import { setSubTotalPrices } from '../utils/setSubTotalPrices.js';
import {
  calculateGrandTotal
} from '../utils/calculateGrandTotal.js';
import {
  uiUpdateByNowAndOrderButton
} from '../payment/uiUpdateByNowAndOrderButton.js';

/**
 * Handles the event for testing a coupon code and triggers the createAndUpdateOrder function.
 *
 * @async
 * @function couponTestClickEventHandler
 * @param {string} privatApiKey - The private API key used to authenticate the coupon test request.
 * @param {string} eventBucketId - The unique identifier for the event bucket being targeted.
 * @returns {Promise<Order>} - A promise that resolves with the order result or an error message if no coupon code is provided.
 */
let lastOrderState = null;

export async function couponTestClickEventHandler(privatApiKey, eventBucketId) {
  const userData = sessionStorageModule.getItem('gd-checkout-data');
  const couponButton = document.getElementById('gd__checkout__discountCode__submit');
  const couponResultInfo = document.getElementById('gd__checkout__discountCode__result');

  // Event Listener nur einmal registrieren
  if (!couponButton.dataset.listenerAdded) {
    couponButton.addEventListener('click', async () => {
      try {
        const couponInputField = document.getElementById(`gd__checkout__discountCode__input`);
        const couponCode = couponInputField?.value || '';

        // Überprüfe, ob der Coupon-Code eingegeben wurde
        if (!couponCode) {
          couponResultInfo.innerText = translation.translatedCouponNotThere; // Hinweis anzeigen
          return; // Fehler zurückgeben, ohne resolve oder reject
        }

        // Verwende createAndUpdateOrder für die Bestellung
        const order = await createAndUpdateOrder(privatApiKey, eventBucketId, userData);
        setSubTotalPrices(order);
        calculateGrandTotal(order);

        // Überprüfe, ob sich die Bestellung geändert hat
        if (JSON.stringify(order) !== JSON.stringify(lastOrderState)) {
          lastOrderState = order; // Update den letzten Zustand
          uiUpdateByNowAndOrderButton(lastOrderState); // Handhabung des Bestellvorgangs
        }
      } catch (error) {
        couponResultInfo.innerText = 'Error during coupon test, please try again.';
        console.error('Error during coupon test:', error);
      }
    });
    couponButton.dataset.listenerAdded = true; // Markiere, dass der Listener hinzugefügt wurde
  }
}

